import React, { useEffect, useRef, useState } from 'react';
import s from './BottomSheet.module.scss';
import { clsx } from '../../utils';

const STORAGE_KEY = '__MODAL_Z_STACK__';
const BASE_Z_INDEX = 1000;

/* -----------------------------
   Session Storage Helpers
------------------------------ */
const getStack = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

const setStack = (stack) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stack));
};

const acquireZIndex = () => {
  const stack = getStack();
  const nextZ = stack.length > 0 ? Math.max(...stack) + 1 : BASE_Z_INDEX + 1;

  stack.push(nextZ);
  setStack(stack);
  return nextZ;
};

const releaseZIndex = (zIndex) => {
  const stack = getStack().filter((z) => z !== zIndex);
  setStack(stack);
};

/* -----------------------------
   BottomSheet Component
------------------------------ */
const BottomSheet = ({
  children,
  isOpen,
  onClose,
  noPadding = false,
  height,
}) => {
  const [mounted, setMounted] = useState(false);
  const [animate, setAnimate] = useState(false);
  const zIndexRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      zIndexRef.current = acquireZIndex(); // 🔥 shared with Modal
      setMounted(true);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setAnimate(true);
        });
      });
    } else {
      setAnimate(false);
      const t = setTimeout(() => {
        setMounted(false);
        releaseZIndex(zIndexRef.current); // 🧹 cleanup
      }, 300);
      return () => clearTimeout(t);
    }
  }, [isOpen]);

  useEffect(() => {
    return () => {
      releaseZIndex(zIndexRef.current);
      zIndexRef.current = null;
    };
  }, []);

  if (!mounted) return null;
  console.log('height', height);
  return (
    <div
      className={s.overlayContainer}
      style={{ zIndex: zIndexRef.current }}
      onClick={onClose}
    >
      <div
        className={clsx(s.sheetContainer, animate ? s.open : s.close)}
        style={{ padding: noPadding ? 0 : '16px 20px 24px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={s.content} style={{ maxHeight: height || 'auto' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default BottomSheet;
